import { render } from "./ActionAgentItem.vue?vue&type=template&id=60655a40&scoped=true"
import script from "./ActionAgentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionAgentItem.vue?vue&type=script&setup=true&lang=js"

import "./ActionAgentItem.vue?vue&type=style&index=0&id=60655a40&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60655a40"],['__file',"src/containers/popup/components/ActionAgentItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60655a40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60655a40', __exports__)) {
    api.reload('60655a40', __exports__)
  }
  
  module.hot.accept("./ActionAgentItem.vue?vue&type=template&id=60655a40&scoped=true", () => {
    api.rerender('60655a40', render)
  })

}


export default __exports__